class BrowserDataStorage {

  constructor(browserApi) {
    this.browserApi = browserApi;
    this.hasLocalStorage = this.browserApi.checkLocalStorage();
  }

  get(key) {
    if (this.hasLocalStorage) {
      if (isNaN(this.browserApi.getLocalItem(key))) {
        return 0;
      }
      return this.browserApi.getLocalItem(key);
    }

    var re = new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$");
    var cookie = this.browserApi.getCookie().replace(re, "$1");
    return cookie;
  }

  set(key, data) {
    if (this.hasLocalStorage) {
      this.browserApi.setLocalItem(key, data);
    }

    this.browserApi.setCookie(key, data);
  }
}

export default BrowserDataStorage;


// WEBPACK FOOTER //
// ./src/utils/browserDataStorage.js